import type { HttpClient } from '../client.js';
import type { ChainRef } from '../internals/chain-ref.js';
import type { ChainSlug } from '../types/chains.js';
import { resolveChain } from '../internals/validation.js';

/**
 * Base for namespaces whose methods accept an optional `chain` argument and
 * fall back to the SDK-wide default chain (`Spectrum.setChain` / config).
 *
 * Provides the shared `resolve()` helper so each namespace doesn't redeclare it.
 */
export abstract class ChainNamespace {
  constructor(
    protected readonly client: HttpClient,
    protected readonly chainRef: ChainRef,
  ) {}

  protected resolve(chain?: ChainSlug): ChainSlug {
    return resolveChain(chain, this.chainRef.current);
  }
}
